import { LineHelpCircle } from '@qr-front/icons/line-help-circle'
import { LogoLink } from 'components/LogoLink/LogoLink'
import { BUILDER_EDIT_MODES, ROUTES } from 'constants/routesConstants'
import { useAtomValue } from 'jotai'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'

import { HeaderContainer } from '@/components/HeaderContainer'
import { userAtom } from '@/global-state'
import { usePathname } from '@/i18n-routing'
import { isNeverPaidUser } from '@/utils/user/isNeverPaidUser'

import { GENERATOR_SEARCH_PARAM } from '../../generatorTypes'
import { HelpDialog } from '../DialogHelp'
import {
	CreateModeGeneratorStepper,
	EditModeGeneratorStepper,
} from '../GeneratorSteppers'
import { GeneratorMobileHeaderContent } from './GeneratorMobileHeaderContent'

export const Clone1GeneratorHeader = () => {
	const searchParams = useSearchParams()
	const pathname = usePathname()
	const user = useAtomValue(userAtom)

	const isNeverPaid = isNeverPaidUser(user)
	const isOnTypeStep = pathname === ROUTES.generator.typeStep
	const hasQrId = searchParams.get(GENERATOR_SEARCH_PARAM.Id) !== null
	const shouldDisableLogoClick = isNeverPaid && (isOnTypeStep || hasQrId)

	const isEditMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) !== null &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.CONTENT

	const isChangeTypeMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) !== null &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.TYPE

	const [isHelpPopupOpen, setIsHelpPopupOpen] = useState(false)

	return (
		<>
			<HeaderContainer className="shadow-[inset_0_-1px_0_0_theme('colors.border-grey-50')]">
				<div className="mx-auto gap-8 desktop:grid desktop:max-w-desktop-container desktop:grid-cols-12">
					<GeneratorMobileHeaderContent
						isEditMode={isEditMode}
						isChangeTypeMode={isChangeTypeMode}
					/>
					<div className="col-span-full col-start-1 hidden items-center justify-between desktop:col-span-12 desktop:flex">
						<LogoLink
							href={
								isNeverPaid
									? ROUTES.generator.typeStep
									: ROUTES.index
							}
							isDisabled={shouldDisableLogoClick}
						/>
						<div className="flex items-center justify-end gap-8 desktop:gap-10">
							{isEditMode ? (
								<EditModeGeneratorStepper />
							) : (
								<CreateModeGeneratorStepper
									isChangeTypeMode={isChangeTypeMode}
								/>
							)}
							<div className="h-[18px] border-r border-border-grey-50" />
							<button
								type="button"
								onClick={() => setIsHelpPopupOpen(true)}
								className="flex"
							>
								<LineHelpCircle className="text-grey transition-colors duration-300 hover:text-blue" />
							</button>
						</div>
					</div>
				</div>
			</HeaderContainer>
			<HelpDialog
				isOpen={isHelpPopupOpen}
				setIsOpen={setIsHelpPopupOpen}
			/>
		</>
	)
}
